import React, { Fragment } from "react";
import { Drawer, Spin, Divider } from "antd";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import map from "lodash/map";
import { goBack } from "connected-react-router";
import Mapping from "components/mapping";
import { mappingActions } from "redux/modules/mappings";
import qs from "querystring";

class MappingCreate extends React.Component {
  constructor(props) {
    super(props);
    const query = qs.parse(props.location.search.substr(1));
    this.state = {
      maskClosable: !!props.match.params.id,
      userId: query.userId
    };
  }

  componentWillMount() {
    const { id } = this.props.match.params;
    if (id && !this.props.mapping) {
      this.props.dispatch(mappingActions.getMapping(id, this.state.userId));
    }
  }

  onClose = () => {
    this.props.dispatch(goBack());
  };

  saveMapping = async val => {
    const { id } = this.props.match.params;
    if (id) {
      return this.props
        .dispatch(mappingActions.updateMapping(id, val))
        .catch(err => {
          throw err.response.data.message;
        });
    } else {
      return this.props.dispatch(mappingActions.saveMapping(val)).catch(err => {
        throw err.response.data.message;
      });
    }
  };

  onChange = isDirty => {
    this.setState({
      maskClosable: !isDirty
    });
  };

  render() {
    const { lab, mapping, loading } = this.props;
    return (
      <Drawer
        visible
        maskClosable={this.state.maskClosable}
        title={mapping ? "Edit mapping" : "Create mapping"}
        width={650}
        onClose={this.onClose}
        style={{
          overflow: "auto",
          // height: "calc(100% - 108px)",
          paddingBottom: "108px"
        }}
      >
        <Helmet title="Create mapping" />
        {!loading ? (
          <Fragment>
            <Mapping
              onChange={this.onChange}
              labData={lab.labData}
              onSave={this.saveMapping}
              mapping={mapping}
              onClose={this.onClose}
            />
            <Divider />
            <h3>Products using this mapping</h3>
            {mapping && mapping.products && mapping.products.length ? (
              <ul>
                {map(mapping.products, i => {
                  const parts = i.id.split(":");
                  const properties = map(i.productOptions, prop => (
                    <span style={{ marginRight: 10 }} key={prop.name}>
                      <strong>{prop.name}:</strong>{" "}
                      <span>{prop.values.join(", ")}</span>
                    </span>
                  ));
                  return (
                    <li key={i.id}>
                      <Link to={`/listings/${parts[1]}`}>
                        <span>
                          ({parts[0]}) {i.title}
                        </span>{" "}
                        <span>|</span> {properties}
                      </Link>
                    </li>
                  );
                })}
              </ul>
            ) : (
              "None"
            )}
          </Fragment>
        ) : (
          <Spin spinning />
        )}
      </Drawer>
    );
  }
}

const mapStateToProps = (state, props) => {
  const id = props.match.params.id;
  const { mappingDetails } = state.mappings;
  return {
    lab: state.lab,
    loading: mappingDetails.loading,
    mapping: mappingDetails[id]
  };
};

export default connect(mapStateToProps)(MappingCreate);
